import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import AddEditOrganizationForm from "@/components/network/AddEditOrganizationForm";

export const Route = createFileRoute("/dashboard/network/organizations/new")({
    component: RouteComponent,
});

function RouteComponent() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    return (
        <AddEditOrganizationForm
            onClose={(shouldRefetch) => {
                if (shouldRefetch) {
                    queryClient.invalidateQueries({
                        queryKey: ["organizations/"],
                    });
                }
                navigate({
                    to: "/dashboard/network/organizations",
                    search: (prev) => prev,
                });
            }}
        />
    );
}
